import { Box, Button, svgIconClasses, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import BaseAddToHomeScreen from 'src/components/icons/AddToHomeScreen';
import { withDefaults } from '../../utils/withDefaults';
import { spreadTypography } from '../../utils/typeUtils';
const TitleRoot = styled(Typography)({});
export const Title = withDefaults(TitleRoot, {
  variant: 'DM Serif H4'
});
export const Description = styled(Typography)(({
  theme
}) => ({
  marginTop: theme.spacing(1.5)
}));
export const List = styled(Box)(({
  theme
}) => ({
  display: 'grid',
  margin: theme.spacing(3, 0),
  gap: theme.spacing(2)
}));
export const Item = styled(Box, {
  shouldForwardProp: prop => prop !== 'bold'
})(({
  theme,
  bold
}) => ({
  display: 'flex',
  alignItems: 'center',
  ...spreadTypography(theme.typography[bold ? 'Lato Emphasized 1' : 'Lato Body 1']),
  [`.${svgIconClasses.root}`]: {
    margin: theme.spacing(0, 0.5)
  }
}));
const HomeScreenIconRoot = styled(BaseAddToHomeScreen)({});
export const HomeScreenIcon = withDefaults(HomeScreenIconRoot, {
  style: {
    marginLeft: 0
  }
});
const DissmisButtonRoot = styled(Button)({});
export const DissmisButton = withDefaults(DissmisButtonRoot, {
  fullWidth: true,
  variant: 'borderless'
});